const config = {
    defaultApp: () => import('@/App'),
    defaultAppId: '#app',
  };

  export default config;
